<template>
  <div class="vi-input">
    <label>
      <!--      <span class="label">{{label}}</span>-->
      <input
        ref="input"
        :type="type"
        :value="value"
        :placeholder="label"
        :disabled="disabled"
        autocapitalize="off"
        @input="onInput"/>
    </label>
  </div>
</template>

<script>
  export default {
    props: {
      label: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: 'text'
      },
      value: {
        type: [String, Number],
        default: null
      },
      disabled: {
        type: Boolean
      },
      autofocus: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      onInput(e) {
        this.$emit('input', e.target.value)
      }
    },
    mounted() {
      if (this.autofocus) {
        try {
          this.$refs.input.focus()
        } catch (e) {

        }
      }
    },

    watch: {
      autofocus() {
       if(this.autofocus) {
         try {
           this.$refs.input.focus()
         } catch (e) {

         }
       }
      }
    }
  }
</script>

<style lang="scss">
  @import "../../styles/vars";

  .vi-input {
    margin-top: 20px;

    label {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .label {
        font-size: 1.1em;
        margin-bottom: 20px;
      }
    }

    input {
      min-width: 180px;
      border-radius: 10px;
      border: none;
      padding: 6px 10px;
      /*text-align: center;*/
      font-size: 16px;
      outline: none;
      box-sizing: border-box;
      width: 100%;

      &:focus {
        box-shadow: 0 0 1px 2px #08A5B4;
      }
    }
  }
</style>
